import arrowDown from "/assets/arrow-down.svg";
import { useState, useEffect, useRef, useMemo } from "react";
import classNames from "classnames";

export default function Select({
  label,
  placeholder,
  value,
  locale,
  defaultValue = null,
  options = {},
  onChange,
  disabled = false,
  errors = [],
}) {
  if (typeof onChange !== "function" && !disabled)
    console.debug("A select doesn't have an onChange callback");

  const [isValid, setIsValid] = useState(errors.length == 0);
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);
  const wrapperRef = useRef(null);
  const optionsRef = useRef(null);
  const labelRef = useRef(null);

  useEffect(() => {
    if (defaultValue && !value) onChange(defaultValue);
  }, []);

  useEffect(() => {
    setIsValid(errors.length == 0);
  }, [errors]);

  useEffect(() => {
    const handleOutsideClick = event => {
      if (!wrapperRef.current || !optionsRef.current) return;

      if (!wrapperRef.current.contains(event.target) &&
          !optionsRef.current.contains(event.target) &&
          !labelRef.current.contains(event.target))
        setIsOptionsVisible(false);
    }

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [wrapperRef]);

  const toggleOptionsVisible = (e) => {
    if (disabled) return;

    setIsOptionsVisible(currentValue => !currentValue);
  };

  const updateValue = (newValue) => {
    setIsValid(true);

    if (typeof onChange === 'function')
      onChange(newValue);

    setIsOptionsVisible(false);
  };

  const selectedOptionName = useMemo(
    () => (value && (locale ? options[value][locale] : options[value])),
    [value, options, locale]
  );

  return (
    <div className="inpt-grp">
      {label && (
        <label onClick={toggleOptionsVisible} ref={labelRef} className="lbl">{label}</label>
      )}
      <div className="inpt-select-wrapper">
        <div className={classNames("inpt-select", { "inpt-select-disabled": disabled, "inpt--error": !isValid })} onClick={toggleOptionsVisible} ref={wrapperRef}>
          <span className="inpt-select-value">{selectedOptionName || placeholder}</span>

          {!disabled && (
            <img src={arrowDown} className={classNames("inpt-select-icon", { "inpt-select-icon-open": isOptionsVisible })} />
          )}
        </div>

        {!isValid && errors.map((error, index) => (
          <label key={index} className="lbl lbl--error">{error}</label>
        ))}

        {isOptionsVisible && (
          <ul className="inpt-select-options" ref={optionsRef}>
            {Object.entries(options).map(([key, data]) => (
              <li
                key={key}
                className={classNames({ "selected": value == key })}
                onClick={() => updateValue(key)}
              >
                {locale ? data[locale] : data}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
